import React, {useRef, useState, useCallback, useEffect} from "react";
import DropDownBox from "devextreme-react/drop-down-box";
import {TreeList} from "devextreme-react/tree-list";
import {Column, Pager, Paging, Scrolling, Selection} from "devextreme-react/tree-list";
import {FilterRow} from "devextreme-react/tree-list";
import './points-tree.scss'
import StorageService from "../../services/storage.service";

export default function PointsTreeHook(props) {
  const treeDataSource = props.points
  const selectionMode = props.selectionMode
  const onSelect = props.onSelect

  let treeViewRef = useRef();
  const [treeBoxValue, setTreeBoxValue] = useState([]);
  const [opened, setOpened] = useState(false)
    useEffect(() => {
        const LocalPointsIds = StorageService.getLocalPoints()
        if (LocalPointsIds) {
            setTreeBoxValue(LocalPointsIds)
        }
    }, [])

  const syncSelection = useCallback((treeView) => {
    try {
        const selectedEmployees = treeView
        onSelect(selectedEmployees)
    } catch (e) {
        onSelect([])
    }

  },[onSelect])

  const syncTreeViewSelection = useCallback(
    (e) => {
      let treeView =
        (e.component.selectItem && e.component) ||
          (treeViewRef.current && treeViewRef.current.instance);
      if (treeView) {
        if (e.value === null) {
          treeView.unselectAll();
        } else {
          let values = e.value || treeBoxValue;
          values &&
          treeView.selectRows(values);
        }

      }

      if (e.value !== undefined) {
        setTreeBoxValue(e.value)
      }
    },
    [treeBoxValue]
  );

  const treeView_itemSelectionChanged = useCallback((e) => {
    const LocalPointsIds = e.component.getSelectedRowsData(selectionMode).map((obj) => obj.id)
          setTreeBoxValue(LocalPointsIds)
    StorageService.setLocalPoints(LocalPointsIds)
    syncSelection(e.component.getSelectedRowsData(selectionMode))
    if (selectionMode === 'single') setOpened(false)
    },
    [setTreeBoxValue,syncSelection,selectionMode]
  );


  let treeViewRender = useCallback(() => {
    return (
        <TreeList
            height="100%"
            id="tree-list-energoobjects"
            ref={treeViewRef}
            dataSource={treeDataSource}
            autoExpandAll={true}
            columnAutoWidth={true}
            showBorders={true}
            dataStructure="plain"
            parentIdExpr="pId"
            keyExpr="id"
            onSelectionChanged={treeView_itemSelectionChanged}
            onNodesInitialized={syncTreeViewSelection}
            onContentReady={syncTreeViewSelection}
            showColumnLines={false}
            filterMode={'fullBranch'}
        >
            <FilterRow visible={true} />
            <Selection mode={selectionMode} recursive={true}/>
            <Scrolling preloadEnabled={true} mode="virtual" />
            <Paging
                enabled={true}
                defaultPageSize={20} />
            <Pager
                showPageSizeSelector={true}
                allowedPageSizes={"auto"}
                showInfo={true} />
            <Column
                dataField="t"
                caption="Название">
            </Column>
            {window.location.hash === '#/energoobjects' &&
            <Column
                dataField="askue"
                width={40}
                allowFiltering={false}
                caption=''
                cellComponent={(props) => {
                    const askue = props.data.data.askue;
                    if (askue && props.data.data.id.includes('_')) {
                        return <i className="dx-icon-chart main-color-light"></i>
                    }
                    return (
                        <></>
                    );
                }}
            />
            }
        </TreeList>
    );
  }, [treeView_itemSelectionChanged, treeDataSource, selectionMode, syncTreeViewSelection]);

  return (
    <div>
          <DropDownBox
              id={'ddb'}
            value={treeBoxValue}
            valueExpr="id"
            displayExpr="t"
            placeholder="Выберите точки учёта"
            showClearButton={false}
            dataSource={treeDataSource}
            onValueChanged={syncTreeViewSelection}
            contentRender={treeViewRender}
            disabled={treeDataSource === null}
            // dropDownOptions={{ minHeight:200}}
            deferRendering={false}
            opened={opened}
            onOptionChanged={(e)=>{if (e.name === 'opened') setOpened(e.value)}}
          />
    </div>
  );
}
